import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { GenericHelp } from '/components/common'
import { GiftPageTutorial } from '/components/GiftPageTutorial'
import api from 'services/api'

import './index.less'

import {
  Typography,
  Button,
  Row,
  Col,
  Form,
  Input,
  notification,
  Icon,
} from 'antd'
const { Text } = Typography
const { TextArea } = Input
import { generateNewFormattedString } from '/utils/checkString.js'

export const GiftSending = ({ title, text, gifUrl, pin }) => {
  const [state, setState] = useState({
    email: '',
    message: '',
    isTutorialVisible: true,
    loading: false,
  })

  const handleEmail = e => {
    setState({ ...state, email: e.target.value })
  }

  const handleTutorialOk = () => {
    setState({ ...state, isTutorialVisible: false })
  }

  const handleTutorialHide = () => {
    localStorage.setItem('hide-tutorial', true)
    handleTutorialOk()
  }

  const editMessage = e => {
    let message = e.target.value
    let newMessage = generateNewFormattedString(message.split(' '))
    setState({ ...state, message: newMessage })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setState({ ...state, loading: true })

    const { email, message } = state
    const { status } = await api.post(`/gift-page-styles/${pin}`, {
      email,
      title,
      text,
      gifUrl,
      message,
    })

    if (status === 200) {
      notification.open({
        message: 'O presente foi enviado com sucesso.',
        icon: <Icon type='smile' style={{ color: '#3ce057' }} />,
      })

      setTimeout(() => location.reload(), 1000)
    } else {
      notification.open({
        message: 'Houve algum problema ao enviar o presente.',
        icon: <Icon type='frown' style={{ color: '#ff0000' }} />,
      })
    }

    setState({ loading: false })
  }

  const hideTutorial = !!localStorage.getItem('hide-tutorial')
  const { isTutorialVisible } = state

  return (
    <Fragment>
      <Row style={{ height: '100%' }}>
        <Col
          xs={{ span: 20, offset: 2 }}
          lg={{ span: 13, offset: 7 }}
          xl={{ offset: 7 }}
          xxl={{ offset: 6 }}
          id='gift-form'
        >
          <Text style={{ fontSize: 20 }}>
            Informe o endereço de e-mail e a mensagem que deseja enviar.
          </Text>

          <Form onSubmit={handleSubmit}>
            <Input
              name='email'
              onChange={handleEmail}
              value={state.email}
              id='email-input'
              placeholder='E-mail'
              required
            />
            <TextArea
              id='email-text'
              name='message'
              placeholder='Coloque aqui uma mensagem especial para ir no email de envio'
              value={state.message}
              onChange={editMessage}
              rows={3}
              required
            />

            <Button
              type='primary'
              className='btn-secondary'
              block
              style={{ height: 45, marginBottom: 5 }}
            >
              <a href='#preview-component'>Pré-visualizar</a>
            </Button>

            <Button
              type='primary'
              htmlType='submit'
              id='submit'
              className='btn'
              loading={state.loading}
              block
            >
              Enviar
            </Button>
          </Form>

          <GenericHelp />
        </Col>
      </Row>
      <GiftPageTutorial
        handleOk={handleTutorialOk}
        handleHide={handleTutorialHide}
        isVisible={isTutorialVisible && !hideTutorial}
      />
    </Fragment>
  )
}

GiftSending.propTypes = {
  /** String chosen by the user to be the title of the gift page */
  title: PropTypes.string,

  /** String chosen by the user to be the text of the gift page */
  text: PropTypes.string,

  /** Gif url chosen by the user */
  gifUrl: PropTypes.string,

  /** Delivery bundle pin */
  pin: PropTypes.string,
}
